// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================
   📊 ResumePointagePage - UX++ Pivot
   ============================ */

   .resume-page h3 {
    color: var(--color-dark-brown);
  }
  
  /* --- Buttons */
  .resume-btn-generate,
  .resume-btn-clear {
    border-radius: 10px;
  }
  
  /* --- Toolbar */
  .resume-toolbar {
    padding: 10px 12px;
    border: 2px solid var(--color-dark-brown);
    border-radius: 12px;
    background: var(--color-beige);
  }
  
  .resume-badge {
    padding: 8px 10px;
    border-radius: 10px;
  }
  
  /* --- Empty state */
  .resume-empty {
    margin-top: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    border: 2px dashed var(--color-light-brown);
    background: rgba(245, 245, 219, 0.6);
    font-weight: bold;
    color: var(--color-dark-brown);
  }
  
  /* ============================
     🔎 react-select (cohérent thème)
     ============================ */
  .resume-react-select .react-select__control {
    border: 1px solid var(--color-dark-brown) !important;
    box-shadow: none !important;
    border-radius: 10px;
  }
  
  .resume-react-select .react-select__control:hover {
    border-color: var(--color-light-brown) !important;
  }
  
  .resume-react-select .react-select__multi-value {
    background-color: rgb(245, 245, 219) !important;
    border: 1px solid var(--color-dark-brown);
    border-radius: 8px;
  }
  
  .resume-react-select .react-select__multi-value__label {
    color: var(--color-dark-brown) !important;
    font-weight: bold;
  }
  
  .resume-react-select .react-select__menu {
    z-index: 9999;
  }
  
  /* ============================
     📦 Table container + scroll
     ============================ */
  .resume-table-container {
    border: 2px solid var(--color-dark-brown);
    border-radius: 12px;
    overflow: hidden;
    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }
  
  .resume-table-scroll {
    max-height: 70vh;
    overflow: auto;
  }
  
  /* ============================
     🧊 Sticky header (2 rows)
     ============================ */
  .resume-pivot-table {
    margin-bottom: 0;
  }
  
  /* Row 1 (top header) */
  .resume-pivot-table thead tr:nth-child(1) th {
    position: sticky;
    top: 0;
    z-index: 30;
    background: rgb(245, 245, 219);
  }
  
  /* Row 2 (sub header) */
  .resume-pivot-table thead tr:nth-child(2) th {
    position: sticky;
    top: 42px; /* ajuste si ton header est plus haut */
    z-index: 25;
    background: rgb(245, 245, 219);
  }
  
  /* ============================
     🧊 Sticky columns (2 left) + shadow
     ============================ */
  .sticky-col {
    position: sticky;
    background: rgb(237, 237, 198);
  }
  
  /* 1ère colonne : Chantier */
  .left-0 {
    left: 0;
    z-index: 40;
    min-width: 240px;
  }
  
  /* 2ème colonne : Ouvrier */
  .left-240 {
    left: 240px;
    z-index: 41;
    min-width: 280px;
  }
  
  /* Ombres pour effet Excel (freeze panes) */
  .resume-sticky-shadow {
    box-shadow: 8px 0 10px rgba(0, 0, 0, 0.05);
  }
  .resume-sticky-shadow-2 {
    box-shadow: 8px 0 10px rgba(0, 0, 0, 0.03);
  }
  
  /* ============================
     📌 Sticky Totaux à droite
     ============================ */
  .sticky-right-0 {
    position: sticky;
    right: 0;
    z-index: 45;
    background: rgb(245, 245, 219);
    min-width: 80px;
  }
  
  .sticky-right-160 {
    position: sticky;
    right: 80px; /* largeur approx de la colonne sticky-right-0 */
    z-index: 45;
    background: rgb(245, 245, 219);
    min-width: 80px;
  }
  
  /* ============================
     🎨 Cells styling
     ============================ */
  .resume-cell-zero {
    background: #fbfbfb !important;
    color: #999 !important;
  }
  
  .resume-cell-nonzero {
    background: #ffffff !important;
    color: #333 !important;
  }
  
  .resume-total-cell {
    background: rgba(245, 245, 219, 0.65) !important;
  }
  
  .resume-chantier-total-row td {
    background: rgba(139, 94, 60, 0.08) !important;
  }
  
  .resume-chantier-total-cell {
    background: rgba(139, 94, 60, 0.08) !important;
    font-weight: bold;
  }
  
  /* Chantier cell content */
  .resume-chantier-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 6px 4px;
  }
  
  .resume-chantier-title {
    font-weight: bold;
    color: var(--color-dark-brown);
  }
  
  .resume-chantier-sub {
    font-size: 12px;
    opacity: 0.85;
  }
  
  /* ✅ Improve table readability */
  .resume-pivot-table th,
  .resume-pivot-table td {
    text-align: center;
    vertical-align: middle !important;
    white-space: nowrap;
    font-size: 14px;
  }
  
  .resume-pivot-table thead th {
    font-weight: bold;
    color: var(--color-dark-brown);
    border-bottom: 2px solid var(--color-dark-brown);
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/ResumePointagePage.css"],"names":[],"mappings":"AAAA;;iCAEiC;;GAE9B;IACC,8BAA8B;EAChC;;EAEA,gBAAgB;EAChB;;IAEE,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,oCAAoC;IACpC,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;;mCAEiC;EACjC;IACE,oDAAoD;IACpD,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,+CAA+C;IAC/C,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;mCAEiC;EACjC;IACE,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;mCAEiC;EACjC;IACE,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,8BAA8B;EAChC;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,SAAS,EAAE,uCAAuC;IAClD,WAAW;IACX,8BAA8B;EAChC;;EAEA;;mCAEiC;EACjC;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA,4BAA4B;EAC5B;IACE,OAAO;IACP,WAAW;IACX,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;;EAEA;;mCAEiC;EACjC;IACE,gBAAgB;IAChB,QAAQ;IACR,WAAW;IACX,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW,EAAE,gDAAgD;IAC7D,WAAW;IACX,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;;mCAEiC;EACjC;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;IAC9C,iBAAiB;EACnB;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA,gCAAgC;EAChC;;IAEE,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,gDAAgD;EAClD","sourcesContent":["/* ============================\r\n   📊 ResumePointagePage - UX++ Pivot\r\n   ============================ */\r\n\r\n   .resume-page h3 {\r\n    color: var(--color-dark-brown);\r\n  }\r\n  \r\n  /* --- Buttons */\r\n  .resume-btn-generate,\r\n  .resume-btn-clear {\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  /* --- Toolbar */\r\n  .resume-toolbar {\r\n    padding: 10px 12px;\r\n    border: 2px solid var(--color-dark-brown);\r\n    border-radius: 12px;\r\n    background: var(--color-beige);\r\n  }\r\n  \r\n  .resume-badge {\r\n    padding: 8px 10px;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  /* --- Empty state */\r\n  .resume-empty {\r\n    margin-top: 12px;\r\n    padding: 14px 16px;\r\n    border-radius: 12px;\r\n    border: 2px dashed var(--color-light-brown);\r\n    background: rgba(245, 245, 219, 0.6);\r\n    font-weight: bold;\r\n    color: var(--color-dark-brown);\r\n  }\r\n  \r\n  /* ============================\r\n     🔎 react-select (cohérent thème)\r\n     ============================ */\r\n  .resume-react-select .react-select__control {\r\n    border: 1px solid var(--color-dark-brown) !important;\r\n    box-shadow: none !important;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .resume-react-select .react-select__control:hover {\r\n    border-color: var(--color-light-brown) !important;\r\n  }\r\n  \r\n  .resume-react-select .react-select__multi-value {\r\n    background-color: rgb(245, 245, 219) !important;\r\n    border: 1px solid var(--color-dark-brown);\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .resume-react-select .react-select__multi-value__label {\r\n    color: var(--color-dark-brown) !important;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .resume-react-select .react-select__menu {\r\n    z-index: 9999;\r\n  }\r\n  \r\n  /* ============================\r\n     📦 Table container + scroll\r\n     ============================ */\r\n  .resume-table-container {\r\n    border: 2px solid var(--color-dark-brown);\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    background: white;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n  }\r\n  \r\n  .resume-table-scroll {\r\n    max-height: 70vh;\r\n    overflow: auto;\r\n  }\r\n  \r\n  /* ============================\r\n     🧊 Sticky header (2 rows)\r\n     ============================ */\r\n  .resume-pivot-table {\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  /* Row 1 (top header) */\r\n  .resume-pivot-table thead tr:nth-child(1) th {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 30;\r\n    background: rgb(245, 245, 219);\r\n  }\r\n  \r\n  /* Row 2 (sub header) */\r\n  .resume-pivot-table thead tr:nth-child(2) th {\r\n    position: sticky;\r\n    top: 42px; /* ajuste si ton header est plus haut */\r\n    z-index: 25;\r\n    background: rgb(245, 245, 219);\r\n  }\r\n  \r\n  /* ============================\r\n     🧊 Sticky columns (2 left) + shadow\r\n     ============================ */\r\n  .sticky-col {\r\n    position: sticky;\r\n    background: rgb(237, 237, 198);\r\n  }\r\n  \r\n  /* 1ère colonne : Chantier */\r\n  .left-0 {\r\n    left: 0;\r\n    z-index: 40;\r\n    min-width: 240px;\r\n  }\r\n  \r\n  /* 2ème colonne : Ouvrier */\r\n  .left-240 {\r\n    left: 240px;\r\n    z-index: 41;\r\n    min-width: 280px;\r\n  }\r\n  \r\n  /* Ombres pour effet Excel (freeze panes) */\r\n  .resume-sticky-shadow {\r\n    box-shadow: 8px 0 10px rgba(0, 0, 0, 0.05);\r\n  }\r\n  .resume-sticky-shadow-2 {\r\n    box-shadow: 8px 0 10px rgba(0, 0, 0, 0.03);\r\n  }\r\n  \r\n  /* ============================\r\n     📌 Sticky Totaux à droite\r\n     ============================ */\r\n  .sticky-right-0 {\r\n    position: sticky;\r\n    right: 0;\r\n    z-index: 45;\r\n    background: rgb(245, 245, 219);\r\n    min-width: 80px;\r\n  }\r\n  \r\n  .sticky-right-160 {\r\n    position: sticky;\r\n    right: 80px; /* largeur approx de la colonne sticky-right-0 */\r\n    z-index: 45;\r\n    background: rgb(245, 245, 219);\r\n    min-width: 80px;\r\n  }\r\n  \r\n  /* ============================\r\n     🎨 Cells styling\r\n     ============================ */\r\n  .resume-cell-zero {\r\n    background: #fbfbfb !important;\r\n    color: #999 !important;\r\n  }\r\n  \r\n  .resume-cell-nonzero {\r\n    background: #ffffff !important;\r\n    color: #333 !important;\r\n  }\r\n  \r\n  .resume-total-cell {\r\n    background: rgba(245, 245, 219, 0.65) !important;\r\n  }\r\n  \r\n  .resume-chantier-total-row td {\r\n    background: rgba(139, 94, 60, 0.08) !important;\r\n  }\r\n  \r\n  .resume-chantier-total-cell {\r\n    background: rgba(139, 94, 60, 0.08) !important;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  /* Chantier cell content */\r\n  .resume-chantier-cell {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 6px;\r\n    padding: 6px 4px;\r\n  }\r\n  \r\n  .resume-chantier-title {\r\n    font-weight: bold;\r\n    color: var(--color-dark-brown);\r\n  }\r\n  \r\n  .resume-chantier-sub {\r\n    font-size: 12px;\r\n    opacity: 0.85;\r\n  }\r\n  \r\n  /* ✅ Improve table readability */\r\n  .resume-pivot-table th,\r\n  .resume-pivot-table td {\r\n    text-align: center;\r\n    vertical-align: middle !important;\r\n    white-space: nowrap;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .resume-pivot-table thead th {\r\n    font-weight: bold;\r\n    color: var(--color-dark-brown);\r\n    border-bottom: 2px solid var(--color-dark-brown);\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
